import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/utils/hooks/reduxHook';
import { validatePhoneNumber } from '../../../app/utils/common/validation';
import { uploadFile } from '../../../redux/API/ProjectAPI';
import { showErrorToast } from '../../../app/utils/common/Toast';
import { createManagerAPI, updateManagerAPI } from '../../../redux/API/ManagerAPI';
import { image } from '../../../app/utils/common/image';
import Input from '../../atoms/Input/Input';
import { getImageURL } from '../../../app/utils/common/getImageUrl';
import ErrorText from '../../atoms/Error/error';
import LoaderScreen from '../../atoms/LoaderScreen/LoaderScreen';
import Button from '../../atoms/Button/Button';
import { createUserAPI, updateUserAPI } from '../../../redux/API/AllUsersAPI';
import { setUserManagementLoading } from '../../../redux/Slices/allUsersSlice';
import CustomRadioButton from '../../atoms/RadioButton/Radio';
import { getAllRoles } from '../../../redux/API/RoleAPI';

const CreateUser = () => {
 
    const navigate = useNavigate();
    const {currentUser, loading} = useAppSelector(state=> state.allUsers)
    const { allRoles } = useAppSelector(state => state.role)

    let { type } = useParams();
    const [name, setName] = useState<string>('');
    const [newProfilePhoto, setNewProfilePhoto] = useState<File>();
    const [profilePhoto, setProfilePhoto] = useState<string>();
    const [phone, setPhone] = useState<string>('');
    const [showError, setShowError] = useState<boolean>(false);
    const [isDataChange, setIsDataChange] = useState<boolean>(false);
    const [roleID, setRoleID] = useState<any>(0);
    const inputRef = useRef<HTMLInputElement>(null);
    const dispatch = useAppDispatch()
    useEffect(() => {
        if (type) {
            if (!["create", "edit"].includes(type)) {
                navigate("/login");
            }
        } else {
            navigate("/login");
        }
    }, [])
    useEffect(() => {
        if (currentUser) {
            if (handleDataChange()) {
                setIsDataChange(true);
            } else {
                setIsDataChange(false);
            }
        }
    }, [name, newProfilePhoto, phone, roleID])

    useEffect(() => {
        if (type === "edit") {
            if (currentUser) {
                setName(currentUser.name);
                setPhone(currentUser.phone_number);
                if (currentUser.profile_image) {
                    setProfilePhoto(currentUser.profile_image);
                }
                setRoleID(currentUser.role_id);  
            } else {
                navigate("/dashboard/manage-user-management");
            }
        }
    }, [])
    const handleDataChange = () => {
        if (currentUser) {
            if (currentUser?.name !== name || currentUser?.phone_number !== phone || newProfilePhoto || currentUser?.role_id !== roleID) return true;
            return false;
        }
        return false;
    }

    const handleRadioChange = (roleId: number) => {
        setRoleID(roleId);
     }

    const handleSubmit = async () => {
        if (validatePhoneNumber(phone) && name.length > 0 && roleID > 0) {
            // api call
            let profile_image_url;
            if (newProfilePhoto) {
                try {
                    dispatch(setUserManagementLoading(true));
                    const imageResp = await uploadFile([newProfilePhoto], "profile");
                    profile_image_url = imageResp.data.imageUrls[0].url;
                } catch (err) {
                    dispatch(setUserManagementLoading(false));
                    showErrorToast("Error in uploading profile image.");
                    return;
                }
            }
            if (type === "create") {
                dispatch(createUserAPI({ role_id: roleID, name, phone_number: phone, profile_image: profile_image_url, country_code: '+91' })).unwrap().then(() => {
                    navigate("/dashboard/manage-user-management");
                }).catch(err => {
                    console.log("user creation error: ", err);
                    showErrorToast(err);
                })
            } else if (type === "edit" && isDataChange && currentUser) {
                let updatedData: any = {}
                if (newProfilePhoto) updatedData.profile_image = profile_image_url;
                if (currentUser?.name !== name) updatedData.name = name;
                if (currentUser?.phone_number !== phone) {
                    updatedData.phone_number = phone;
                    updatedData.country_code = "+91";
                }
                updatedData.role_id = roleID
                updatedData.user_id = currentUser.user_id;
                dispatch(updateUserAPI(updatedData)).unwrap().then(() => {
                    navigate("/dashboard/manage-user-management");
                }).catch(err => {
                    console.log("user update error", err);
                });
            }
        } else {
            setShowError(true);
        }
    }
    return (
        <div className='create_project_container' >
            {
                <input type='file' accept='image/*' style={{ display: "none" }} ref={inputRef} onChange={(e) => {
                    if (e.target.files) {
                        setNewProfilePhoto(e.target.files[0])
                    }
                }} />
            }
            <div className='create_project_header_container'>
                <img className='back_icon' src={image.BACK_ICON} onClick={() => {
                    navigate(-1);
                }} />
                <div className='header_text'>{type === "edit" ? "Edit" : "Add"} User</div>
            </div>
            <div className='group-details-container broker-add-container'>
                <div className='group-container add-broker-container'>
                    <div >
                        <div className='profile-picture-container' >
                            <img src={newProfilePhoto ? URL.createObjectURL(newProfilePhoto) : profilePhoto ? getImageURL(profilePhoto) : image.DEFAULT_PROFILE_IMAGE} className='broker-profile' />
                            <img src={image.CAMERA_PHOTO} alt="camera icon" className="add-broker-profile" onClick={() => inputRef.current?.click()} />
                        </div>
                    </div>
                    <div className='broker-main-container'>
                        <div className='group-name-container'>
                            <div className='group-photo'>Name*</div>
                            <Input
                                placeholder="Enter Name"
                                type="text"
                                name="broker Name"
                                id="brokerName"
                                value={name}
                                onChange={(e) => { setName(e.target.value) }}
                                iconSrc={image.USER_NAME_ICON}
                                showIcon={true}
                            />
                            {showError && name.trim().length == 0 && <ErrorText message="Please provide user's name" />}
                        </div>
    
                        <div className='group-name-container'>
                            <div className='group-photo'>Phone Number*</div>
                            <Input
                                placeholder="Enter Phone Number"
                                type="number"
                                name="broker number"
                                id="brokerNumber"
                                value={phone}
                                onChange={(e) => { if (e.target.value.length <= 10) setPhone(e.target.value) }}
                                iconSrc={image.PhoneLogo}
                                showIcon={true}
                            />
                            {showError && !validatePhoneNumber(phone) && <ErrorText message="Please provide valid user's phone number." />}
                        </div>
                    </div>
                    <div>
                        <div className="group-photo">Select a role*</div>
                        <div>
                            {allRoles?.length > 0 &&
                                allRoles.map((role, index) => (
                                    <div key={role.role_id}>  
                                        <div style={{ display: "flex", gap: "10px", fontFamily: "Lufga", marginBottom: "10px", fontWeight: "700" }}>
                                            {(role.role_id !== 2 && role.role_id !== 3) &&
                                                <>
                                                    <CustomRadioButton
                                                        onClick={() => {
                                                            handleRadioChange(role.role_id);
                                                        }}
                                                        checked={role.role_id === roleID}  
                                                        />
                                                    <div>
                                                        {role.role_name}
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    {showError && !roleID && <ErrorText message="Please select a role" />}
                    <div className='grp-submit-container' style={{ marginLeft: "0px" }}>
                        {
                            loading ? <LoaderScreen /> :
                                <Button buttonTitle={type === "create" ? "Submit" : "Update"} onClick={() => handleSubmit()} className='group_btn_submit' />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateUser
